import { Component, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { HubRecordEditorBase } from '../_hub_record_editor_base';
import { ClassicEditor, Bold, Essentials, Italic, Paragraph, List, Link } from 'ckeditor5';

@Component({
    selector: 'app-summary-edit',
    templateUrl: './summary-edit.component.html',
    styleUrls: ['./summary-edit.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SummaryEditComponent extends HubRecordEditorBase {
    public Editor = ClassicEditor;

    public ckEditorConfig = {
        licenseKey: 'GPL',
        plugins: [Essentials, Paragraph, Bold, Italic, List, Link],
        toolbar: ['bold', 'italic', 'link', 'numberedList', 'bulletedList']
    };

    private _anchorRecord = false;

    public get isOfRecordTypeForAnchorRecord() {
        return this.isProject || this.isStrategy || this.isWholeSystem;
    }

    public get anchorRecord() {
        if (!this._anchorRecord) {
            this._anchorRecord = this.project && this.project.insightRecords && this.project.insightRecords.filter((record) => record.anchorRecordFlag).length > 0;
        }
        return this._anchorRecord;
    }

    public projectNameChanged(projectName): void {
        const summaryControl = this.projectEditForm!.controls.name as FormControl;
        summaryControl.setValue(projectName);
        summaryControl.markAsDirty();
        summaryControl.updateValueAndValidity();
    }

    public projectNameValidityChanged(isValid: boolean): void {
        this.isProjectNameValid = isValid;
    }
}
